module.exports = __webpack_public_path__ + "img/markito.4de22ab3.png";